import MainArticleSection from './MainArticleSection';

export default MainArticleSection;
